// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserLink__userLink-f8bd25 {
  color: inherit;
  font-weight: bold;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/System/UserLink/UserLink.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AACF","sourcesContent":[".userLink {\n  color: inherit;\n  font-weight: bold;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userLink": `UserLink__userLink-f8bd25`
};
module.exports = ___CSS_LOADER_EXPORT___;
